(() => {
  if (window.__abmPaymentFinancingReady) return;
  window.__abmPaymentFinancingReady = true;

  const notify = input => {
    if (!input) return;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const syncPaymentTerms = (root, forceVariantUpdate = false) => {
    const buyForm = root.querySelector('[data-abm-product-form]');
    const mainVariant = buyForm?.querySelector('[name="id"]');
    const mainQuantity = buyForm?.querySelector('[name="quantity"]');
    const paymentVariant = root.querySelector('[data-abm-payment-variant-id]');
    const paymentQuantity = root.querySelector('[data-abm-payment-quantity]');

    if (paymentVariant && mainVariant?.value) {
      const changed = String(paymentVariant.value) !== String(mainVariant.value);
      if (changed) paymentVariant.value = mainVariant.value;
      if (changed || forceVariantUpdate) notify(paymentVariant);
    }

    const quantity = Math.max(1, Number.parseInt(mainQuantity?.value || '1', 10) || 1);
    if (paymentQuantity) {
      const changed = String(paymentQuantity.value) !== String(quantity);
      if (changed) paymentQuantity.value = String(quantity);
      if (changed) notify(paymentQuantity);
    }
  };

  const init = root => {
    if (!root || root.dataset.abmPaymentReady === 'true') return;
    root.dataset.abmPaymentReady = 'true';

    const quantity = root.querySelector('[data-abm-product-form] [name="quantity"]');
    quantity?.addEventListener('input', () => syncPaymentTerms(root));
    quantity?.addEventListener('change', () => syncPaymentTerms(root));

    root.addEventListener('click', event => {
      if (!event.target.closest('[data-abm-option-index][data-abm-option-value]')) return;
      window.setTimeout(() => syncPaymentTerms(root, true), 0);
    });

    root.addEventListener('change', event => {
      if (!event.target.closest('[data-abm-option-select]')) return;
      window.setTimeout(() => syncPaymentTerms(root, true), 0);
    });

    syncPaymentTerms(root);
  };

  const boot = () => document.querySelectorAll('[data-abm-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();